'use client';

import { ToastContainer } from 'react-toastify';
import { useSearchParams, usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

/**
 *  Toast 訊息 SearchParams 中的 ?success=成功了 與 ?error=失敗了
 */
const useSearchParamsMessage = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const successMsg = searchParams.get('success');
    const errorMsg = searchParams.get('error');

    if (!successMsg && !errorMsg) return;

    if (successMsg) toast.success(successMsg);
    if (errorMsg) toast.error(errorMsg);

    const nextSearchParams = new URLSearchParams();
    searchParams.forEach((value, name) => {
      if (name === 'success' || name === 'error') return;
      nextSearchParams.append(name, value);
    });

    router.replace(`${pathname}?${nextSearchParams.toString()}`);
  }, [searchParams]);
};

export default function ToastProvider() {
  useSearchParamsMessage();

  return (
    <ToastContainer
      theme="colored"
      position="top-center"
    />
  );
}
